<template>

  <div class="plus-container" v-loading="loading">
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" >创建店铺</el-button></div>
    <div>
      <div class="common-form">我的店铺</div>
      <div class="plus-list">
        <div class="item" v-for="(item, index) in listData" :key="index">
          <div class="item-box">
            <a href="javascript:void(0);">
              <span class="iconfont2" @click="settingClick({type:item.type,port_id:item.port_id})">
                <svg t="1596881858883" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="586" width="48" height="48"><path d="M608.6 290.3c67.1 0 121.7 50.5 121.7 112.9 0 19.4-5.6 38.4-15.7 55.5-15.3 25-39.8 43.5-69.4 52.3-7.9 2.3-13.9 3.2-19.4 3.2-13 0-23.1-10.2-23.1-23.1 0-13 10.2-23.1 23.1-23.1 0.9 0 2.8 0 5.1-0.9 19.9-5.6 35.6-17.1 44.4-32.4 6-9.7 8.8-20.4 8.8-31.5 0-36.6-33.8-66.6-75-66.6-14.4 0-28.2 3.7-40.7 10.6-21.8 12.5-34.7 33.3-34.7 56v193.9c0 39.3-21.8 75.4-57.9 95.8-19.4 11.1-41.2 16.7-63.4 16.7-67.1 0-121.7-50.5-121.7-112.9 0-19.4 5.6-38.4 15.7-55.5 15.3-25 39.8-43.5 69.4-52.3 8.3-2.3 13.9-3.2 19.4-3.2 13 0 23.1 10.2 23.1 23.1 0 13-10.2 23.1-23.1 23.1-0.9 0-2.8 0-5.1 0.9-19.9 6-35.6 17.6-44.4 32.4-6 9.7-8.8 20.4-8.8 31.5 0 36.6 33.8 66.6 75.4 66.6 14.4 0 28.2-3.7 40.7-10.6 21.8-12.5 34.7-33.3 34.7-56V403.3c0-39.3 21.8-75.4 57.9-95.8 19-11.6 40.7-17.2 63-17.2zM510.8 929c231.1 0 418.4-187.3 418.4-418.4S741.9 92.1 510.8 92.1 92.4 279.5 92.4 510.6 279.7 929 510.8 929z m0 22C267.5 951 70.3 753.8 70.3 510.6S267.5 70.1 510.8 70.1s440.5 197.2 440.5 440.5S754.1 951 510.8 951z" p-id="587"></path></svg></span>
                <div class="ml10">
                <p>{{item.port_name}}</p>
                <p @click="managerClick({type:item.type,port_id:item.port_id});" v-if="item.auth_type==1">发布管理</p>
                <p>端口号:{{item.port_id}}</p>
                <p>类型:{{item.type}}</p>
                <p>
                  <span @click="settingClick({type:item.type,port_id:item.port_id});" style="margin-right: 5px;">编辑</span>
                  <span @click="deleteClick({type:item.type,port_id:item.port_id})">删除</span>
                </p>
              </div>
              <div class="copy" @click="handleCopy(item.port_id, $event)">
                复制端口号
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="common-form">营销端口</div>
      <div class="plus-list">

        <div class="item">
          <div class="item-box">
            <a href="javascript:void(0);" @click="quickClick({type:'wxapp'})">
              <span class="iconfont2"><img src="@/assets/img/wxapp.png" alt=""></span>
              <div class="ml10">
                <p>微信小程序</p>

                <p class="btm-p">马上创建</p>
              </div>
            </a>
          </div>
        </div>

        <div class="item">
          <div class="item-box">
            <a href="javascript:void(0);" @click="quickClick({type:'h5'})">
              <span class="iconfont2"><img src="@/assets/img/h5.png" alt=""></span>
              <div class="ml10">
                <p>H5版本</p>

                <p class="btm-p">马上创建</p>
              </div>
            </a>
          </div>
        </div>

        <div class="item">
          <div class="item-box">
            <a href="javascript:void(0);" @click="quickClick({type:'android'})">
              <span class="iconfont2"><img src="@/assets/img/android.png" alt=""></span>
              <div class="ml10">
                <p>安卓版</p>

                <p class="btm-p">马上创建</p>
              </div>
            </a>
          </div>
        </div>


        <div class="item">
          <div class="item-box">
            <a href="javascript:void(0);" @click="quickClick({type:'ios'})">
              <span class="iconfont2"><img src="@/assets/img/ios.png" alt=""></span>
              <div class="ml10">
                <p>IOS版本</p>

                <p class="btm-p">马上创建</p>
              </div>
            </a>
          </div>
        </div>

        
          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'zhifubao'})">
                <span class="iconfont2"><img src="@/assets/img/zhifubao.png" alt=""></span>
                <div class="ml10">
                  <p>支付宝小程序</p>

                  <p class="btm-p" >马上创建</p>
                </div>
              </a>
            </div>
          </div>

          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'baidu'})">
                <span class="iconfont2"><img src="@/assets/img/baidu.png" alt=""></span>
                <div class="ml10">
                  <p>百度小程序</p>

                  <p class="btm-p" >马上创建</p>
                </div>
              </a>
            </div>
          </div>

          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'douyin'})">
                <span class="iconfont2"><img src="@/assets/img/douyin.png" alt=""></span>
                <div class="ml10">
                  <p>字节跳动小程序</p>

                  <p class="btm-p" >马上创建</p>
                </div>
              </a>
            </div>
          </div>


          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'qq'})">
                <span class="iconfont2"><img src="@/assets/img/qq.png" alt=""></span>
                <div class="ml10">
                  <p>QQ小程序</p>

                  <p class="btm-p" >马上创建</p>
                </div>
              </a>
            </div>
          </div>


          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'quick'})">
                <span class="iconfont2"><img src="@/assets/img/quick.png" alt=""></span>
                <div class="ml10">
                  <p>快应用</p>
                  <p class="btm-p" >马上创建</p>
                </div>
              </a>
            </div>
          </div>


          <div class="item">
            <div class="item-box">
              <a href="javascript:void(0);" @click="quickClick({type:'360'})">
                <span class="iconfont2"><img src="@/assets/img/360.png" alt=""></span>
                <div class="ml10">
                  <p>360小程序</p>

                  <p class="btm-p">马上创建</p>
                </div>
              </a>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortApi from '@/api/port.js';

export default {
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*数据*/
      listData:[],
      /*插件列表数据*/
      list: []
    };
  },
  created() {
    this.getData();
  },

  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      PortApi.portList({}, true)
        .then(res => {
          self.loading = false;
          self.listData=res.data.list.data;
          //self.buildTree(data.data.list, false);
        })
        .catch(error => {});
    },
    addClick(){
      this.$router.push({
        path: '/plus/port/port/select',
      });
    },
    managerClick(row){
      this.$router.push({
        path:"/plus/port/manager/index",
        query:{
          type:row.type,
          port_id:row.port_id
        }
      })
    },
    settingClick(row){
      this.$router.push({
        path:"/plus/port/port/edit",
        query:{
          port_id:row.port_id,
          type:row.type
        }
      })
    },
    deleteClick(row){
      this.$confirm("删除后不可恢复，确认删除该配置吗?", "提示", {type: "warning"}).then(() => {
        let self = this;
        let params={}
        params.port_id = row.port_id;
        if(row.type == "wxapp" || row.type == "wxmp"){
          PortApi.deletPort(params, true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              self.getData();
              //self.buildTree(data.data.list, false);
            })
            .catch(error => {});
        }else{
          PortApi.delet(params, true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              self.getData();
              //self.buildTree(data.data.list, false);
            })
            .catch(error => {});
        }
      })
    },
    quickClick(row){
      let self = this;
      if(row.type!='wxapp'){
          self.$message({
            message: '联系管理员创建',
            type: 'error'
          });
          return false
      }else{
        this.$router.push({
          path:"/plus/port/port/select",
          query:{
            type:'wxapp'
          }
        })
      }
    }
  }
};
</script>

<style>
  .plus-container{ min-height: 400px;}
.plus-container .common-form{ margin-bottom: 0;}
.plus-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.plus-list .item {
  margin-top: 10px;
  width: 25%;
}
.plus-list .item .item-box {
  padding: 10px;
  border: 1px solid #f5f7fa;
}
.plus-list .item a {
  display: flex;
  height: 60px;
  padding-left: 10px;
  justify-content: flex-start;
  align-items: center;
}
.plus-list .item .item-box .copy{
  margin-left: 25px;
}
.plus-list .item a h3 {
  font-weight: normal;
  color: #333333;
}
.plus-list .item a:hover h3 {
  color: #3a8ee6;
}
.plus-list .item a .pstyle {
  width: 60px;
  font-size: 12px;
  color: #999999;
}
.btm-p{
  margin-top: 30px;
}
.plus-list .item .item-box .iconfont2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  line-height: 80px;
}
.plus-list .item a .svg-icon {
  width: 22px;
  height: 22px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/port/port/index.vue